import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const options = {
	order: ['path']
}

i18n.use(LanguageDetector).use(initReactI18next).init({
	defaultNS: 'translations',
	detection: options,
	fallbackLng: 'en',
	ns: ['translations'],
	resources: {
		ar: {
			// eslint-disable-next-line global-require
			translations: require('./locales/ar.json')
		},
		de: {
			// eslint-disable-next-line global-require
			translations: require('./locales/de.json')
		},
		el: {
			// eslint-disable-next-line global-require
			translations: require('./locales/el.json')
		},
		es: {
			// eslint-disable-next-line global-require
			translations: require('./locales/es.json')
		},
		fr: {
			// eslint-disable-next-line global-require
			translations: require('./locales/fr.json')
		},
		it: {
			// eslint-disable-next-line global-require
			translations: require('./locales/it.json')
		},
		ja: {
			// eslint-disable-next-line global-require
			translations: require('./locales/ja.json')
		},
		'pt-BR': {
			// eslint-disable-next-line global-require
			translations: require('./locales/pt.json')
		},
		'pt-PT': {
			// eslint-disable-next-line global-require
			translations: require('./locales/pt.json')
		},
		ru: {
			// eslint-disable-next-line global-require
			translations: require('./locales/ru.json')
		},
		'zh-Hans': {
			// eslint-disable-next-line global-require
			translations: require('./locales/zh.json')
		}
	}
})

i18n.languages = ['fr', 'de', 'es', 'pt-PT', 'pt-BR', 'it', 'ar', 'zh-Hans', 'ru', 'ja', 'el'];

export default i18n;
